import Dashboard from "./Dashboard";
import ShopifyIntegrationsPage from "./ShopifyIntegrationsPage";

const ShopifyIntegrationsRoute = () => (
  <Dashboard initialSection="clientes" customContent={<ShopifyIntegrationsPage />} />
);

export default ShopifyIntegrationsRoute;

